<template>
  <el-dialog
    top="5vh"
    class="dialog-full-medium"
    width="600px"
    title="发起退款"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :before-close="handleClose"
    @open="handleOpen"
    append-to-body
    custom-class="set-dialog__body"
  >
    <div class="dialog__body">
      <el-form
        :model="ruleForm"
        :rules="rules"
        size="small"
        ref="ruleForm"
        label-width="120px"
        label-position="left"
      >
        <div class="content-header">
          <div class="h-left">
            <data-show label="服务商: ">
              {{dataObj.payeeBusinessName || '-'}}
            </data-show>
            <div class="num">{{dataObj.refundAmount | toFenThousandsAndFloat('¥')}}</div>
          </div>
          <div class="h-right">
            <data-show label="供应商: ">
              {{dataObj.businessName || '-'}}
            </data-show>
            <div>退款金额</div>
          </div>
        </div>

        <!-- 综合/单个(银行/支付宝)发起支付-类型切换 -->
        <el-tabs v-model="activeName" @tab-click="handleTabsClick">
          <!-- 现金确认 -->
          <template v-if="type === 'cashpay'">
            <el-tab-pane label="附件信息" name="cashpay" />
          </template>
          <template v-else>
            <el-tab-pane label="线上支付" name="online" v-if="type === 'online'" />
            <el-tab-pane label="线下支付" name="offline" v-if="type === 'offline'" />
          </template>
        </el-tabs>

        <!-- 线上支付 -->
        <div class="tab-message" v-if="activeName === 'online'">
          <div class="main-cont-item">
            <h2 class="title-text">
              {{isAliPayMode ? '收款账户信息':'目标银行账户信息'}}
            </h2>
            <bank-info :dataObj="dataObj" />
          </div>
          <payways-list
            ref="payWaysListRef"
            payCodeType="2"
            :paymentInfoNewList="paymentInfoNewList"
            :loading="channelLoading"
            :paymentObj="dataObj"
            :payMethodObj="payMethodObj"
            :code.sync="ruleForm.code"
            :channelCode.sync="ruleForm.channelCode"
            @channelCodeChange="channelCodeChange"
            @paymentChannelChange="paymentChannelChange"
          />
        </div>
        <!-- 人工支付 -->
        <div class="tab-message" v-if="activeName === 'offline'">
          <div class="main-cont-item">
            <h2 class="title-text">目标账户信息</h2>
            <bank-info :dataObj="dataObj" />
          </div>
          <div class="main-cont-item">
            <h2 class="title-text">出款账户信息</h2>
            <el-form-item prop="bankAccountNo" class="form-item-box">
              <el-row :gutter="20">
                <el-col :span="16">
                  <select-account
                    :bankAccount="ruleForm.bankAccountNo"
                    :bakAcctList="bakAcctList"
                    @change="bankAccountNoChange"
                  />
                </el-col>
              </el-row>
            </el-form-item>
          </div>
          <div class="main-cont-item">
            <h2 class="title-text">上传凭证</h2>
            <el-form-item prop="imageList" class="form-item-box">
              <upload
                accept=".jpg, .jpeg, .png,.pdf"
                :fileLimit="999"
                path="payment/offline/"
                :file-list="ruleForm.picUrl"
                :uploading.sync="uploading"
                @update="handleUploadUpdate"
                @upload-paste="handleUploadPaste"
              />
            </el-form-item>
          </div>
        </div>
        <!-- 现金确认 -->
        <div class="tab-message" v-if="activeName === 'cashpay'">
          <div class="main-cont-item">
            <h2 class="title-text">上传凭证</h2>
            <el-form-item prop="cashImage" class="form-item-box">
              <upload
                accept=".jpg, .jpeg, .png,.pdf"
                :limit="999"
                path="refund/offline/"
                :file-list="ruleForm.picUrl"
                :uploading.sync="uploading"
                @update="handleUploadUpdate"
                @upload-paste="handleUploadPaste"
              />
            </el-form-item>
          </div>
          <div class="main-cont-item">
            <h2 class="title-text">备注</h2>
            <el-form-item prop="remark" class="form-item-box">
              <el-input
                type="textarea"
                placeholder="请备注说明付款的方式和账户"
                v-model="ruleForm.remark"
                show-word-limit
                :rows="3"
              />
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <template v-if="$has('FWS-NXDD-TKJL-TJ')">
        <el-button @click="handleClose" :size="formSize">取消</el-button>
        <el-button
          type="primary"
          :size="formSize"
          @click="submit"
          :loading="submitLoading"
          :disabled="uploading"
        >
          提交
        </el-button>
      </template>
      <el-button v-else @click="handleClose" :size="formSize">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getRefundPayMethod, setPayOnlineSubmit, setPayOfflineSubmit } from '@/api/refund';
import { getAakAcctList } from '@/api/receivables/receive';
import Upload from '@/components/upload';
import bankInfo from './bank-info';
import SelectAccount from '@/views/components/select-accont/select-account';
import paywaysList from '@/views/components/payways-list';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    /**
     * 类型：
     * online: 线上,
     * offline: 线下,
     * cashpay: 现金确认
    */
    type: {
      type: String,
      default: 'online',
    },
    refundOrderNo: {
      type: String,
      default: '',
    },
    dataObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch: {
    activeName() {
      this.$refs.ruleForm.resetFields();
    },
  },
  components: { Upload, bankInfo, SelectAccount, paywaysList },
  data() {
    const that = this;
    const validatePicUrl = (rule, value, callback) => {
      if (!that.ruleForm.imageList || that.ruleForm.imageList.length === 0) {
        callback(new Error('请上传凭证'));
      } else {
        callback();
      }
    };
    return {
      uploading: false,
      activeName: 'online',
      isAliPayMode: true,
      ruleForm: {
        code: '',
        paymentChannelNo: '',
        paymentChannelName: '',
        picUrl: [],
        imageList: [],
        channelCode: '',
        bankAccountNo: '',
        channelNo: '',
        payeeBusinessNo: '',
      },
      rules: {
        code: [
          { required: true, message: '短信验证码不能为空', trigger: 'blur' },
        ],
        paymentChannelNo: [
          { required: true, message: '选择不能为空', trigger: 'change' },
        ],
        channelCode: [
          { required: true, message: '选择不能为空', trigger: 'change' },
        ],
        imageList: [
          { validator: validatePicUrl, trigger: 'blur' },
        ],
        remark: [
          { required: true, message: '备注不能为空', trigger: 'blur' },
        ],
        bankAccountNo: [
          { required: true, message: '选择不能为空', trigger: 'change' },
        ],
      },
      bakAcctList: [], // 出款账户
      currentAccount: {}, // 选中账户
      submitLoading: false,
      paymentInfoList: [],
      payMethodObj: {
        needCode: '',
        paymentReqId: '',
      },
      channelLoading: false,
      paymentInfoNewList: [],
    };
  },
  methods: {
    // tab切换
    handleTabsClick() {
      this.$refs.ruleForm.resetFields();
      if (this.activeName === 'online') {
        this.ruleForm.channelCode = this.paymentInfoNewList.length ? 'ybpay' : ''; // 默认显示易宝数据
        this.$nextTick(() => {
          this.$refs.payWaysListRef.channelCodeChange('ybpay');
        });
      }
    },
    // 图片上传返回
    handleUploadUpdate(images) {
      this.ruleForm.picUrl = (images || []).map((item) => (item));
      this.ruleForm.imageList = JSON.parse(JSON.stringify(this.ruleForm.picUrl));
      this.$refs.ruleForm.validateField('imageList');
    },
    // 图片粘贴返回
    handleUploadPaste(image) {
      this.ruleForm.picUrl.push(image);
      this.ruleForm.imageList = JSON.parse(JSON.stringify(this.ruleForm.picUrl));
      this.$refs.ruleForm.validateField('imageList');
    },
    // 关闭
    handleClose() {
      this.$emit('update:visible', false);
      this.$emit('update:paymentNo', '');
      if (this.$refs.payWaysListRef) {
        this.$refs.payWaysListRef.clearInterval();
      }
    },
    // 打开窗口前
    handleOpen() {
      this.$nextTick(() => {
        this.isAliPayMode = this.dataObj.payMode === 'ALIPAY';
        const list = {
          all: 'online',
          online: 'online',
          offline: 'offline',
          cashpay: 'cashpay',
        };
        this.activeName = (list[this.type] || 'online');
        this.ruleForm = {
          code: '',
          paymentChannelNo: '',
          paymentChannelName: '',
          channelCode: '',
          picUrl: [],
          bankAccountNo: '',
          channelNo: '',
          payeeBusinessNo: '',
        };
        this.currentAccount = {};
        this.bakAcctList = [];
        if (this.activeName === 'online') this._getPayMethod();
        if (this.type !== 'online') this._getAakAcctList();
        this.$refs.ruleForm.resetFields();
      });
    },
    async _getPayMethod(mergePay = 2) {
      try {
        this.paymentInfoList = [];
        this.payMethodObj = {
          needCode: '',
          paymentReqId: '',
        };
        this.channelLoading = true;
        const res = await getRefundPayMethod({ refundOrderNo: this.refundOrderNo, mergePay });
        const { paymentInfoNew, needCode, paymentReqId } = res?.data || {};
        // this.paymentInfoList = paymentInfo || [];
        this.paymentInfoNewList = paymentInfoNew || [];
        this.ruleForm.channelCode = this.paymentInfoNewList.length ? 'ybpay' : ''; // 默认显示易宝数据
        this.$nextTick(() => {
          this.$refs.payWaysListRef.channelCodeChange('ybpay');
        });
        this.payMethodObj = {
          needCode,
          paymentReqId,
        };
      } catch (error) {
        console.log(error);
      } finally {
        this.channelLoading = false;
      }
    },
    _getAakAcctList() {
      const obj = {
        BANK_CARD: '1',
        ALIPAY: '2',
        WECHAT: '3',
      };
      const value = obj[this.dataObj?.refundWay || 'BANK_CARD'];
      getAakAcctList({
        accountCategory: value,
        principalType: 0,
      }).then((res) => {
        this.bakAcctList = res.data || [];
      });
    },
    // 提交
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.activeName === 'online') {
            this.handleOnline(2);
            return;
          }
          this.handleOffline();
        }
      });
    },
    // 线上
    handleOnline(mergePay) {
      const { paymentChannelNo, code, paymentChannelName, channelNo, payeeBusinessNo } = this.ruleForm;
      const params = {
        code, // 验证码
        mergePay, // 机构代付合并标识,1 不合并(批量支付) , 2 合并(合并支付)
        paymentChannelName, // 付款渠道名称
        paymentChannelNo, // 付款渠道编号
        paymentReqId: this.payMethodObj.paymentReqId, // 付款提交Id
        refundOrderNo: this.refundOrderNo,
        channelNo,
        payeeBusinessNo,
      };
      this.submitLoading = true;
      setPayOnlineSubmit(params).then(() => {
        this.$message.success('操作成功！');
        this.handleClose();
        this.$emit('success');
      }).finally(() => {
        this.submitLoading = false;
      });
    },
    // 线下
    handleOffline() {
      const { picUrl, remark, bankAccountNo } = this.ruleForm;
      const [receiptTypeItme] = this.bakAcctList.filter((el) => el.bankAccountNo === bankAccountNo);
      const { accountNumber, accountName, bankName, payBankBranchInfo, payBankAccountType } = receiptTypeItme || {};
      const urlList = (picUrl || []).map(((item) => item.fileId));
      const params = {
        accountName: accountName || '', // 出款户名
        accountNumber: accountNumber || '', // 出款账户
        bankName: bankName || '', // 银行名称
        payAmount: this.dataObj.refundAmount ?? 0, // 付款金额
        payBankAccountType: payBankAccountType || '', // 账户类型
        payBankBranchInfo: payBankBranchInfo || '', // 支行名称
        pic: urlList?.join(',') || '', // 付款图片
        refundOrderNo: this.refundOrderNo,
        remark,
        refundChannel: this.type === 'cashpay' ? 'CASH_PAY' : 'OFFLINE_TRANS', // 退款渠道：OFFLINE_TRANS-线下转账, CASH_PAY-现金，默认 OFFLINE_TRANS
      };
      this.submitLoading = true;
      setPayOfflineSubmit(params).then(() => {
        this.$message.success('操作成功！');
        this.handleClose();
        this.$emit('success');
      }).finally(() => {
        this.submitLoading = false;
      });
    },
    // 账户选择
    bankAccountNoChange(no) {
      this.ruleForm.bankAccountNo = no;
    },
    paymentChannelChange(data) {
      const { paymentChannelName, paymentChannelNo, channelNo, payeeBusinessNo } = data;
      this.ruleForm.paymentChannelName = paymentChannelName || '';
      this.ruleForm.paymentChannelNo = paymentChannelNo || '';
      this.ruleForm.payeeBusinessNo = payeeBusinessNo || '';
      this.ruleForm.channelNo = channelNo || '';
      this.$refs.ruleForm.validateField('paymentChannelNo');
    },
    // 付款渠道选择
    channelCodeChange(data) {
      const { paymentChannelNo, paymentChannelName, channelCode, payeeBusinessNo, channelNo } = data;
      this.ruleForm.channelCode = channelCode || '';
      this.ruleForm.paymentChannelNo = paymentChannelNo || '';
      this.ruleForm.paymentChannelName = paymentChannelName || '';
      this.ruleForm.payeeBusinessNo = payeeBusinessNo || '';
      this.ruleForm.channelNo = channelNo || '';
    },
  },
};
</script>


<style lang="scss" scoped>
::v-deep {
  .form-item-box {
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .payment-channel {
    margin-bottom: 0 !important;
    .el-radio {
      display: flex;
      line-height: 20px;
      align-items: center;
      .el-radio__label {
        white-space: break-spaces;
      }
    }
  }
  .el-tabs__header {
    margin: 0;
  }
  .el-button {
    min-width: 64px;
    padding: 8px 16px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
  }
  .el-dialog {
    min-width: 600px;
    .el-dialog__body {
      overflow-x: hidden;
    }
  }
  .title-text {
    margin-top: 16px;
  }
}
.set-dialog__body {
  .main-cont-item {
    padding-bottom: 16px;
    margin-bottom: 0;
    border: none;
    h2 {
      font-size: 14px;
    }
    &:last-child {
      padding-bottom: 0px;
    }
  }
  .tab-message {
    max-height: 60vh;
    overflow: auto;
    overflow-x: hidden;
  }
}

.content-header {
  .h-left {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .name {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #4d4f51;
      line-height: 20px;
    }
    .num {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ff3741;
      line-height: 30px;
    }
  }
  .h-right {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #c9ccd1;
    line-height: 18px;
  }
}
</style>
